module.exports = __webpack_public_path__ + "fonts/Dancing-Bold.woff!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Dancing-Bold.woff
// module id = 45
// module chunks = 0